import { useContext } from 'react';

import { TenancyContext } from 'shared/contexts/TenancyContext';

export const useTenancyContext = () => {
  const context = useContext(TenancyContext);

  if (context === undefined) {
    throw new Error('useTenancyContext must be used within a TenancyContextProvider');
  }

  return context;
};
